"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _index = _interopRequireDefault(require("./config/index"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getConfig = function getConfig() {
  var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var baseUrl = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.baseUrl) || _index["default"].baseUrl;
  var resource = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.resource) || _index["default"].resource;
  var path = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.path) || _index["default"].path;
  var data = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.data) || _index["default"].data;
  var defaultData = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.defaultData) || _index["default"].defaultData;
  var url = "".concat(baseUrl).concat(resource).concat(path);
  url = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.url) || url;
  var config = {
    url: url,
    headers: (dataSource === null || dataSource === void 0 ? void 0 : dataSource.headers) || _index["default"].headers,
    timeout: (dataSource === null || dataSource === void 0 ? void 0 : dataSource.timeout) || _index["default"].timeout,
    method: (dataSource === null || dataSource === void 0 ? void 0 : dataSource.method) || _index["default"].method
  };

  if (dataSource !== null && dataSource !== void 0 && dataSource.auth) {
    config = _objectSpread(_objectSpread({}, config), {}, {
      auth: dataSource === null || dataSource === void 0 ? void 0 : dataSource.auth
    });
  }

  data = _objectSpread(_objectSpread({}, defaultData), data);

  if (config.method.toUpperCase() === 'GET') {
    config.params = data;
  } else {
    config.data = data;
  }

  return config;
};

var request = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var dataSource,
        config,
        validResponseJSON,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataSource = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            config = getConfig(dataSource);
            validResponseJSON = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.validResponseJSON) || _index["default"].validResponseJSON;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              (0, _axios["default"])(config).then(function (response) {
                if (validResponseJSON) {
                  try {
                    JSON.parse(JSON.stringify(response));
                  } catch (err) {
                    reject({
                      message: "The returned format is not JSON"
                    });
                  }
                }

                resolve(response);
              })["catch"](function (error) {
                reject(error);
              });
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function request() {
    return _ref.apply(this, arguments);
  };
}();

module.exports = request;